import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getActiveTemplatesApi = ({ offset, limit, includeCount }) =>
  sendRequest({
    url: endpoints.templates.engagement.activeTemplates,
    credentials: 'include',
    queryParams: {
      offset,
      limit,
      include_count: includeCount,
    },
  });

export const getSampleTemplatesApi = ({ offset, limit, includeCount }) =>
  sendRequest({
    url: endpoints.templates.engagement.sampleTemplates,
    credentials: 'include',
    queryParams: {
      offset,
      limit,
      include_count: includeCount,
    },
  });

export const getArchivedTemplatesApi = ({ offset, limit, includeCount }) =>
  sendRequest({
    url: endpoints.templates.engagement.archivedTemplates,
    credentials: 'include',
    queryParams: {
      offset,
      limit,
      include_count: includeCount,
    },
  });

export const getTemplateStructureApi = ({ templateId }) =>
  sendRequest({
    url: endpoints.templates.engagement.templateStructure,
    credentials: 'include',
    queryParams: {
      template_id: templateId,
    },
  });

export const createTemplateStructureApi = ({ templateId, body }) =>
  sendRequest({
    url: endpoints.templates.engagement.templateStructure,
    credentials: 'include',
    method: 'POST',
    body: {
      ...body,
    },
  });

export const updateTemplateStructureApi = ({ templateId, body }) =>
  sendRequest({
    url: endpoints.templates.engagement.templateStructure,
    credentials: 'include',
    method: 'PUT',
    body: {
      ...body,
    },
    queryParams: {
      template_id: templateId,
    },
  });

export const archiveTemplateApi = ({ templateId, isArchive }) =>
  sendRequest({
    url: endpoints.templates.engagement.archiveTemplate,
    credentials: 'include',
    method: 'POST',
    queryParams: {
      template_id: templateId,
      is_archive: isArchive,
    },
  });

export const duplicateTemplateApi = ({ templateId }) =>
  sendRequest({
    url: endpoints.templates.engagement.duplicateTemplate,
    credentials: 'include',
    method: 'POST',
    queryParams: {
      template_id: templateId,
    },
  });
